import { defineStore } from 'pinia'
import { ref } from 'vue'

// Animation duration matches the CSS animation (1.5s)
const ANIMATION_DURATION = 1500

export const useLoadingStore = defineStore('loading', () => {
    // For the loading bar animation (visual only)
    const showLoadingBar = ref(false)
    // For content display (shows immediately when ready)
    const isContentLoading = ref(false)

    let loadingTimeout: ReturnType<typeof setTimeout> | null = null
    let animationStartTime: number | null = null

    function startLoading() {
        // Clear any pending timeout
        if (loadingTimeout) {
            clearTimeout(loadingTimeout)
            loadingTimeout = null
        }
        showLoadingBar.value = true
        isContentLoading.value = true
        animationStartTime = Date.now()
    }

    function stopLoading() {
        // Content shows immediately
        isContentLoading.value = false

        if (!animationStartTime) {
            showLoadingBar.value = false
            return
        }

        // Loading bar waits to complete animation cycle
        const elapsed = Date.now() - animationStartTime
        const remainingTime = ANIMATION_DURATION - (elapsed % ANIMATION_DURATION)

        loadingTimeout = setTimeout(() => {
            showLoadingBar.value = false
            loadingTimeout = null
            animationStartTime = null
        }, remainingTime)
    }

    return {
        showLoadingBar,
        isContentLoading,
        startLoading,
        stopLoading
    }
})
